import React, { Component } from "react";
import Accessibility from "./Accessibility";

export default class CodeViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minify: false,
    };

    this.setMinify = this.setMinify.bind(this);
    this.copytoClipBoard = this.copytoClipBoard.bind(this)
  }

  setMinify(e) {
    this.setState({ minify: !this.state.minify })
  }

  copytoClipBoard() {
    let copyArea = document.getElementById("copyArea");
    copyArea.select();
    copyArea.setSelectionRange(0, 99999);
    document.execCommand("copy");
    alert("Content has been copied to the clipboard");
  }

  render() {
    let accessibility = this.props.a11y.length ? (
      <Accessibility accessibility={this.props.a11y} />
    ) : null;

    return (
      <div className="modal">
        {/* <pre><code style={{width: '80%'}}>{props.emailBody}</code></pre> */}
        <textarea readOnly id="copyArea" value={this.state.minify ? this.props.minBody : this.props.emailBody}></textarea>
        <label class='minify-label'><input type='checkbox' checked={this.state.minify} onChange={this.setMinify}></input> Minify Results</label>
        <button className="copy-button" onClick={this.copytoClipBoard}>
          COPY TO CLIPBOARD
        </button>
        {accessibility}
      </div>
    );
  }
}
